export default "__VITE_ASSET__DfLRoWlP__"